var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInProgress(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.56 25.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Set_of_64_UI_Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.78,0C5.72,0,0,5.72,0,12.78s5.72,12.78,12.78,12.78,12.78-5.72,12.78-12.78S19.84,0,12.78,0ZM5.49,15.27c-1.37,0-2.49-1.11-2.49-2.49s1.11-2.49,2.49-2.49,2.49,1.11,2.49,2.49-1.11,2.49-2.49,2.49Zm7.29,0c-1.37,0-2.49-1.11-2.49-2.49s1.11-2.49,2.49-2.49,2.49,1.11,2.49,2.49-1.11,2.49-2.49,2.49Zm7.29,0c-1.37,0-2.49-1.11-2.49-2.49s1.11-2.49,2.49-2.49,2.49,1.11,2.49,2.49-1.11,2.49-2.49,2.49Z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgress);
export default __webpack_public_path__ + "static/media/in-progress.f52354bb7b1faf2dc9f4e37ad5e79e6c.svg";
export { ForwardRef as ReactComponent };